/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./DeleteInventoryRestockDialog.vue?vue&type=template&id=72b17efd"
import script from "./DeleteInventoryRestockDialog.vue?vue&type=script&lang=js"
export * from "./DeleteInventoryRestockDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72b17efd')) {
      api.createRecord('72b17efd', component.options)
    } else {
      api.reload('72b17efd', component.options)
    }
    module.hot.accept("./DeleteInventoryRestockDialog.vue?vue&type=template&id=72b17efd", function () {
      api.rerender('72b17efd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventory/DeleteInventoryRestockDialog.vue"
export default component.exports